import type { PostHog } from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://eu.i.posthog.com";

// PostHog est chargé PARESSEUSEMENT (import dynamique) et seulement quand le
// navigateur est inactif, pour ne peser ni sur le bundle critique ni sur le
// chemin de rendu initial. Les events émis avant le chargement attendent la
// promesse et partent dès que PostHog est prêt.
let phPromise: Promise<PostHog | null> | null = null;

function ensurePostHog(): Promise<PostHog | null> {
  if (!POSTHOG_KEY) return Promise.resolve(null);
  if (!phPromise) {
    phPromise = new Promise((resolve) => {
      const load = () =>
        import("posthog-js").then(({ default: posthog }) => {
          posthog.init(POSTHOG_KEY, {
            api_host: POSTHOG_HOST,
            capture_pageview: false, // géré manuellement via PostHogPageView
            capture_pageleave: true,
            persistence: "localStorage+cookie",
          });
          resolve(posthog);
        });
      if (typeof window !== "undefined" && "requestIdleCallback" in window) {
        (window as unknown as { requestIdleCallback: (cb: () => void, o?: { timeout: number }) => void })
          .requestIdleCallback(load, { timeout: 4000 });
      } else {
        setTimeout(load, 1500);
      }
    });
  }
  return phPromise;
}

/** Planifie le chargement de PostHog (sur temps libre). */
export function initPostHog() {
  ensurePostHog();
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  ensurePostHog().then((ph) => ph?.capture(name, properties));
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  ensurePostHog().then((ph) => ph?.identify(userId, traits));
}

export function resetUser() {
  ensurePostHog().then((ph) => ph?.reset());
}

export function capturePageview(properties?: Record<string, unknown>) {
  ensurePostHog().then((ph) => ph?.capture("$pageview", properties));
}
